<div class="card card-statistics mb-30" [hidden]="Switcher_form=='Check'">
  <div class="card-body">
    <h5 class="card-title">Request Daily Leave</h5>
    <form [formGroup]="AddNewOffday" (submit)="CheckOffday()">

      <input type="hidden" formControlName="id" />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">From Date </label>
          <input formControlName="startDate" #vaziat_startDateInput type="text" class="form-control"
            placeholder="Type here...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_startDateInput"></ng-persian-datepicker>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">To Date </label>
          <input formControlName="endDate" #vaziat_endDateInput type="text" class="form-control"
            placeholder="Type here...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_endDateInput"></ng-persian-datepicker>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"><button type="button" (click)="openModal_Person(templatePerson)"
              class="btn btn-danger left"> Select Substitute<i class="fa fa-user"></i> </button> </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_Record.fullname}}" />
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Description </label>
          <input formControlName="dsc" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_dsc().valid && get_Form_dsc().touched"
            class="form-text text-muted MyErrorRedColor">Enter the description.</small>
        </div>
      </div>
      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewOffday.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Review Leave Information </button>
      <button routerLink="/Offday" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>
    </form>
  </div>
</div>

<div class="card card-statistics mb-30" [hidden]="Switcher_form=='Insert'">
  <div class="card-body">
    <h5 class="card-title">Request Daily Leave</h5>
    <form [formGroup]="AddNewOffday" (submit)="CheckOffday()">

      <input type="hidden" formControlName="id" />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Start Date </label>
          <input disabled type="text" value="{{startDate_fulldate}}" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> End Date </label>
          <input disabled type="text" value="{{endDate_fulldate}}" class="form-control" placeholder="Type here...">
        </div>
        
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Substitute </label>
          <input disabled type="text" value="{{Data_Seleted_Record.fullname}}" class="form-control" placeholder="Type here...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Working Day </label>
          <input disabled type="text" value="{{on}}" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Holiday </label>
          <input disabled type="text" value="{{off}}" class="form-control" placeholder="Type here...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Description </label>
          <input disabled type="text" value="{{get_Form_dsc().value}}" class="form-control" placeholder="Type here...">
        </div>
      </div>
      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="button" (click)="SubmitAddNewOffday()" [disabled]="!AddNewOffday.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Confirm and Save </button>
      <button *ngIf="!InProccessing" type="button" (click)="set_Switcher_form('Insert')" class="btn btn-danger"
        style="margin-right: 5px;"><i class="fa fa-times-rectangle"></i> Cancel </button>
      <button routerLink="/Offday" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>
    </form>
  </div>
</div>



<ng-template #templatePerson>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Personnel List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Person.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Full Name</label>
          <input type="text" class="form-control" [(ngModel)]="Search_Name_Person_Table"
            placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Full Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Person
            |filter:Search_Name_Person_Table:'fullname'
            | paginate
                    : {
                        id: 'DataList_Person',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Person|filter:Search_Name_Person_Table:'fullname').length
                      }">
              <td>{{DataList_Person.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td (click)="Set_Selected_Person_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingPerson" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingPerson" type="button" (click)="ReadData_Person()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Person.hide()">Close</button>
  </div>
</ng-template>